import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import { GuidedTour } from './GuidedTour';

const SSI_ROLES = new Set(['SSIAdministrator', 'SSIEmployee']);

/**
 * Map pathname prefixes to CMS tour names (seeded in tooltip_content).
 * First matching prefix wins.
 *
 * Paths are basename-relative (router basename is `/v2`) — do NOT include `/v2`.
 */
const ROUTE_TOURS: Array<{ prefix: string; tourName: string }> = [
  { prefix: '/dashboard', tourName: 'dashboard-first-run' },
  { prefix: '/properties', tourName: 'properties-first-run' },
  { prefix: '/drawing-vault', tourName: 'drawings-first-run' },
];

/**
 * Mounts at most one auto-start spotlight tour for the current route.
 * SSI operators skip customer first-run chrome by default (activation spike D2).
 */
export function FirstRunTourHost() {
  const pathname = useLocation().pathname;
  const role = useAuthStore((s) => s.user?.role);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  const tourName = useMemo(() => {
    if (!isAuthenticated || !role || SSI_ROLES.has(role)) return null;
    const match = ROUTE_TOURS.find((r) => pathname.startsWith(r.prefix));
    return match?.tourName ?? null;
  }, [isAuthenticated, pathname, role]);

  if (!tourName) return null;
  return <GuidedTour key={tourName} tourName={tourName} autoStart />;
}
